import { userInfoStore } from "Stores";

export class Umami {
  instance: umami_ns.umami;
  constructor() {
    this.instance = window.umami;
  }

  track(eventName: string, eventType?: { [key: string]: string | number }) {
    if (this.instance) {
      this.instance.track((props) => ({ ...props, name: eventName, data: { ...eventType, userId: userInfoStore.id } }));
    }
  }
}

export const umami = new Umami();
